module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#F6F8FE",
      "height": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.backBtn
    }
  }, [_vm._v("\n\t\t\t\t 返回\n\t\t\t ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "addEnterprises"
  }, [_c('div', {
    staticClass: "accinfo"
  }, [_c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("数据类型")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("DataTypeFilter")(this.DataType)))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("患者编号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.Code))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("患者姓名")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.PersonName))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("订单日期")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.DateRecord))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("所属医院")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.Hospital))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("文件码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.FileCode))])]), _vm._v(" "), _vm._m(0), _c('div', {
    staticStyle: {
      "margin-left": "120px",
      "margin-top": "-40px"
    },
    attrs: {
      "id": "qrcode"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("H5连接")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": 'http://112.125.27.239:3801/#/case/' + this.FileCode,
      "target": "_blank"
    }
  }, [_vm._v("http://112.125.27.239:3801/#/case/" + _vm._s(this.FileCode))])])]), _vm._v(" "), _vm._m(1), _c('div', {
    staticStyle: {
      "margin-left": "120px",
      "margin-top": "-40px"
    },
    attrs: {
      "id": "qrcode1"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("CT文件")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.FileCodeStatus))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("Dicom")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.FileCodeDcmStatus))])])]), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "alterBtn",
    on: {
      "click": _vm.alterBtn
    }
  }, [_vm._v("修改")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("App二维码")]), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("H5二维码")]), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a9d9c46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/FileInfo.vue
// module id = 1096
// module chunks = 1